import React from "react";
import { TermsOfServiceDialog } from "./TermsOfServiceDialog";
import { useIsPublicPage } from "../../lib/routing";
import { useSelector, useDispatch } from "react-redux";
import { setPreference } from "../../components/Preferences/preferencesActions";
import { TERMS_ACCEPTED, DOMICILE, UI_LANG } from "../../redux/slices/api/initialisePreferences";

export const TermsOfService = () => {
  const isPublicPage = useIsPublicPage();
  const preferences = useSelector((state) => state.preferences);
  const isTermsAccepted = parseInt(preferences[TERMS_ACCEPTED][0]);
  const domicile = preferences[DOMICILE][0];
  const lang = preferences[UI_LANG][0];
  const dispatch = useDispatch();

  const onReject = () => (window.location = "http://www.nomura.com");
  const onAccept = () => dispatch(setPreference({ key: TERMS_ACCEPTED, value: 1 }, true));
  if (!isTermsAccepted && !isPublicPage) {
    return (
      <TermsOfServiceDialog
        show={!isTermsAccepted}
        domicile={domicile}
        lang={lang}
        onAccept={onAccept}
        onReject={onReject}
      />
    );
  } else {
    return null;
  }
};
